const DEFAULT_STEP_CARDS = [
  { step: 1, title: 'Initial Information Required', instruction: '', progressMessage: '' },
  { step: 2, title: 'Tax Return Preparation', instruction: '', progressMessage: 'Working for Employee' },
  { step: 3, title: 'Review Draft Tax Return', instruction: '', progressMessage: 'Fill Form', clientPendingInstruction: '', clientPendingProgressMessage: 'Signature PDF' },
  { step: 4, title: 'Return sent for Filing', instruction: '', progressMessage: 'Employee Draft Check', clientPendingInstruction: '', clientPendingProgressMessage: 'Signature PDF' },
];

export const getTaxFilingPageMeta = (content) => {
  const stepCards = (content?.stepCards?.length ? content.stepCards : DEFAULT_STEP_CARDS)
    .map((card, index) => ({ ...DEFAULT_STEP_CARDS[index], ...card }));

  return {
    instructionBanner: content?.instructionBanner || '',
    tourButtonLabel: content?.tourButtonLabel || 'Start Interactive Tour',
    formBadgePrefix: content?.formBadgePrefix || 'Form ',
    lockedBannerTitle: content?.lockedBannerTitle || 'Tax Filing Locked',
    lockedBannerText: content?.lockedBannerText || 'Pay to unlock and start your new tax filing cycle',
    lockedPayButtonLabel: content?.lockedPayButtonLabel || 'Pay $150 to Unlock',
    wipBannerTitle: content?.wipBannerTitle || 'Work In Progress',
    wipBannerText: content?.wipBannerText || 'Work is in progress, but payment is still pending.',
    wipPayButtonLabel: content?.wipPayButtonLabel || 'Complete Payment',
    historyTitle: content?.historyTitle || 'Tax Filing History',
    summaryTableTitle: content?.summaryTableTitle || 'Tax Filing Summary – Primary Member',
    memberSummaryTableTitle: content?.memberSummaryTableTitle || 'Tax Filing Summary – {name}',
    stepCards,
    forms: content?.forms || {},
  };
};

export const getStepCardMeta = (stepCards, step, status) => {
  const card = stepCards.find((item) => item.step === step) || {};
  const isClientPending = status === 'client-pending';
  return {
    title: card.title || `Step ${step}`,
    instruction: isClientPending && card.clientPendingInstruction
      ? card.clientPendingInstruction
      : card.instruction || '',
    progressMessage: isClientPending && card.clientPendingProgressMessage
      ? card.clientPendingProgressMessage
      : card.progressMessage || '',
  };
};

export const mergeStepsWithPortal = (steps, stepCards) => {
  if (!Array.isArray(steps) || !steps.length) {
    return stepCards.map((card) => ({
      step: card.step,
      title: card.title,
      status: card.step === 1 ? 'in-progress' : 'pending',
      progress: 0,
      answers: card.step === 1 ? {} : undefined,
      comments: card.step === 1 ? {} : undefined,
      files: card.step === 1 ? [] : undefined,
    }));
  }

  return steps.map((step) => {
    const card = stepCards.find((item) => item.step === step.step);
    return card?.title ? { ...step, title: card.title } : step;
  });
};

export const getFormBadgeLabel = (formType, meta) => {
  const form = meta?.forms?.[formType];
  if (form?.label) return form.label;
  return `${meta?.formBadgePrefix || 'Form '}${formType}`;
};

export const formatTemplate = (template, vars = {}) =>
  (template || '').replace(/\{(\w+)\}/g, (_, key) => (vars[key] !== undefined ? vars[key] : `{${key}}`));
